import {
  AccessibilityNew,
  Build,
  Description,
  NoteAdd,
  Opacity,
  Timeline,
} from "@material-ui/icons";
import React from "react";

import {
  DataGraphPage,
  FilesPage,
  PressManagementPage,
  RegisterPage,
  RemoteMaintenancePage,
  ReportPage,
} from "../pages";

/**
 * ファイル一覧ドロワー項目.
 *
 * @type {object}
 */
export const filesDrawerItem = {
  id: "files",
  path: "/files",
  name: "ファイル一覧",
  component: <FilesPage />,
  icon: <Description />,
};

/**
 * データ登録ドロワー項目.
 *
 * @type {object}
 */
export const registerDrawerItem = {
  id: "register",
  path: "/register",
  name: "データ登録",
  component: <RegisterPage />,
  icon: <NoteAdd />,
};

/**
 * データグラフドロワー項目.
 *
 * @type {object}
 */
export const dataGraphDrawerItem = {
  id: "dataGraph",
  path: "/dataGraph",
  name: "データグラフ",
  component: <DataGraphPage />,
  icon: <Timeline />,
};

/**
 * 診断カルテドロワー項目.
 *
 * @type {object}
 */
export const reportDrawerItem = {
  id: "report",
  path: "/report",
  name: "診断カルテ",
  component: <ReportPage />,
  icon: <Opacity />,
};

/**
 * リモート保守ドロワー項目.
 *
 * @type {object}
 */
export const remoteMaintenanceDrawerItem = {
  id: "remoteMaintenance",
  path: "/remoteMaintenance",
  name: "リモート保守",
  component: <RemoteMaintenancePage />,
  icon: <AccessibilityNew />,
};

/**
 * 工番管理ドロワー項目.
 *
 * @type {object}
 */
export const pressManagementDrawerItem = {
  id: "pressManagement",
  path: "/pressManagement",
  name: "工番管理",
  component: <PressManagementPage />,
  icon: <Build />,
};

/**
 * ドロワー項目リスト.
 *
 * @type {object}
 */
export const drawerItems = {
  files: filesDrawerItem,
  register: registerDrawerItem,
  dataGraph: dataGraphDrawerItem,
  report: reportDrawerItem,
  remoteMaintenance: remoteMaintenanceDrawerItem,
  pressManagement: pressManagementDrawerItem,
};
